import { Component, inject, ChangeDetectionStrategy, input } from '@angular/core';

import {ClmPerformanceOutput} from "../../../../model/clm-performance-output";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-w2w-sw-com-heating-performance-output',
  imports: [MatIcon],
  templateUrl: './w2w-sw-com-heating-performance-output.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './w2w-sw-com-heating-performance-output.component.css'
})
export class W2wSwComHeatingPerformanceOutputComponent {
  private readonly userStateService = inject(UserStateService);


  readonly results = input.required<ClmPerformanceOutput>();
  isExpanded = true;
  private sectionKey = ConfigurationSection.HEATING_PERFORMANCE_RESULTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  hasMessages(): boolean {
    return (this.results()?.messages?.length || 0) > 0;
  }

}
